import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Welcome / introduction step shown before the first data section.
 *
 * @param {string} clientName - Personalises the greeting.
 */
export default function StepWelcome({ clientName }) {
  return (
    <div className="cashflow-welcome">
      <BrandLogo size={72} className="mb-3" />
      <h1 className="h3 fw-bold cashflow-brand-text mb-3">
        Welcome{clientName ? `, ${clientName.split(' ')[0]}` : ''}!
      </h1>

      <p className="lead text-muted mb-4">
        Thank you for scheduling your upcoming Financial Planning Review.
        Please complete this short questionnaire so our team can best
        prepare for your goals, questions, and update your plan. This may
        take about 10–20 minutes.
      </p>

      <div className="alert alert-light border-start border-4 border-danger mb-4 py-3">
        <h6 className="fw-bold mb-2">
          <i className="bi bi-lightbulb me-2 text-danger" />
          Before you start
        </h6>
        <ul className="mb-0 small text-muted ps-3">
          <li>Have your most recent pay stubs, account statements, and tax return handy.</li>
          <li>Your progress is <strong>saved automatically</strong> when you click Next.</li>
          <li>You can return to this page anytime using the same link your advisor sent you.</li>
          <li>Estimates are fine — it doesn't have to be perfect.</li>
          <li>
            After you submit, you'll get a chance to securely upload any
            supporting documents to your <strong>Client Portal</strong>.
          </li>
        </ul>
      </div>

      <div className="row g-3">
        {[
          { icon: 'bi-person-vcard', label: 'Personal Info', desc: 'Verify your contact details.' },
          { icon: 'bi-people', label: 'Life Updates', desc: 'Family, career, and finance changes.' },
          { icon: 'bi-bank', label: 'Accounts & Income', desc: 'Cash savings and recurring income.' },
          { icon: 'bi-credit-card', label: 'Debts & Expenses', desc: 'Loans and recurring expenses.' },
        ].map(({ icon, label, desc }) => (
          <div key={label} className="col-6 col-md-3">
            <div className="card border-0 bg-light h-100 text-center p-3">
              <i className={`bi ${icon} fs-3 text-danger mb-2`} />
              <div className="fw-semibold small">{label}</div>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>{desc}</div>
            </div>
          </div>
        ))}
      </div>

      <p className="text-muted small mt-4 mb-0">
        Click <strong>Next</strong> to begin.
      </p>
    </div>
  );
}
